import { useState } from 'react';
import Layout from '@/components/Layout';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { signIn } from 'next-auth/react';
import { getSession } from 'next-auth/react';


const fetchUrl = process.env.NEXT_PUBLIC_BASE_ENDPOINT + 'signup';

export default function SignUp() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [errorMessage, setError] = useState('');
    const [loading, setLoading] = useState(false);

    let router = useRouter();

    const handleSignup = async (e) => {
        e.preventDefault();

        if (password !== repeatPassword) {
            setError('Las contraseñas no coinciden.') 
            return;
        } 

        setLoading(true); 

        let bodyParsed = {
            email,
            password,
            repeatPassword,
        };
        let bodyMessage = JSON.stringify(bodyParsed);

        try {
            const ret = await fetch('api/auth/signup', {
                method: 'POST',
                body: bodyMessage,
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const response = await ret.json();
            if (ret.status === 200 && response.token) {
                setError('');
                await firstSignIn(email, password);
            } else {
                setError(response.message);
            }
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    const firstSignIn = async (email, password) => {
        setLoading(true);
        try {
            const ret = await signIn('credentials', {
                email,
                password,
                redirect: false,
            });
            router.push('/signup-2');
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    // function onChange(value) {
    //    console.log("Captcha value:", value);
    // }
    
    return (
        <>
            <div className="signup form-pages">
                <form className="signup-form form" onSubmit={handleSignup}>
                    <div className="backbutton">
                        <Link className="backbutton" href='/browse'>&lt; Volver</Link>
                    </div>
                    <h2>Registrate en AUF TV</h2>
                    <label>Email </label>
                    <input
                        type="email"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <label>Contraseña: </label>
                    <input
                        type="password"
                        placeholder="Contraseña"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    ></input>
                    <label>Repetí la contraseña: </label>
                    <input
                        type="password"
                        placeholder="Repetir contraseña"
                        required
                        value={repeatPassword}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                    ></input>
                    <button disabled={loading}>Registrate</button>
                    {errorMessage && <p className="error">{errorMessage}</p>}
                    
                    
                    <div className="no-account">
                        ¿Ya tenés una cuenta?{' '}
                        <Link href="/signin">
                            <a className="signupLink">Ingresá acá</a>
                        </Link>
                        .
                    </div>
                </form>
            </div>
        </>
    );
}

SignUp.getLayout = function getLayout(page) {
    return (
        <Layout title="Registrate en AUFTV" className="signup form-pages">
            {page}
        </Layout>
    );
};

export async function getServerSideProps(ctx) {
    const session = await getSession(ctx);

    if (session) {
        return {
            redirect: {
                permanent: false,
                destination: '/browse',
            },
            props: {},
        };
    }

    // Pass data to the page via props
    return { props: { session: session } };
}
